import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'calendarEvent';

const calendarEventService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  getRow: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/row/${encodeURIComponent(id)}`,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default calendarEventService;
